import { render, staticRenderFns } from "./AddloonlakwerkpagePage.vue?vue&type=template&id=1b58cc0a"
import script from "./AddloonlakwerkpagePage.vue?vue&type=script&lang=js"
export * from "./AddloonlakwerkpagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports